import React from 'react';
import { FaTh } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';
import { Link } from 'react-router-dom';

function MainMenu({ hanldeOffset }) {
    return (
        <>
            <div className="main-menu-area">
                <div className="row align-center">
                    <div className="col-6 col-md-9 col-lg-11">
                        <div className="main-menu">
                            <ul>
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <Link to="/">Products</Link>
                                    <ul className="sub-menu">
                                        <li>
                                            <Link to="/PlateletRichPlasmaKits">CliniMACS System </Link>
                                        </li>
                                        <li>
                                            <Link to="/gmpProducts">MACS GMP Products </Link>
                                        </li>
                                        <li>
                                            <Link to="/transplantationMedicine">Transfusion / Transplantation Medicine </Link>
                                        </li>
                                        <li>
                                            <Link to="/cordBloodBankingKits">Cord Blood Banking</Link>
                                        </li>
                                        <li>
                                            <Link to="/tissueCellProcessing">Tissue / Cell Processing  </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <Link to="/services">Services & Applications</Link>
                                    <ul className="sub-menu">
                                        <li>
                                            <Link to="/clinical-applications">Clinical Applications</Link>
                                        </li>
                                        <li>
                                            <Link to="/cgmp-Products">cGMP Products</Link>
                                        </li>
                                        <li>
                                            <Link to="/turnKeyProject">Turn Key Projects</Link>
                                        </li>
                                        <li>
                                            <Link to="/CellGeneTherapy">Cell and gene therapy</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <Link to="/news">News / Events</Link>
                                </li>
                                <li>
                                    <Link to="/downloads">Downloads</Link>
                                </li>
                                <li>
                                    <Link to="/about">About Us</Link>
                                </li>
                                <li>
                                    <Link to="/contact">Contact Us</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-6 col-md-8 col-lg-1 icon-wrapper">
                        <button type="button" onClick={hanldeOffset} className="side-menu-toggle">
                            <FaTh />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MainMenu;
